import React, { useContext } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import { Footer as SharedFooter } from '@spotify-internal/masthead-react';

import { MastheadFooter } from 'utils/masthead/masthead';
import { MarketContext } from 'providers/market';

interface Props {
  data?: MastheadFooter;
}

export const Footer = ({ data }: Props) => {
  const { locale, preferredDir } = useContext(MarketContext);

  if (!data) return null;

  const topLinkGroups = cloneDeep(data.topLinkGroups);

  // Custom Contact us link for en-US markets
  if (locale === 'en-US' && topLinkGroups.length) {
    topLinkGroups[topLinkGroups.length - 1].links.push({
      title: 'Contact Spotify',
      href: 'https://support.spotify.com/article/contact-us/?in_footer',
    });
  }

  return (
    <div dir={preferredDir}>
      <SharedFooter {...data} topLinkGroups={topLinkGroups} />
    </div>
  );
};
